module.exports = __webpack_public_path__ + "img/file_icon.4c358175.svg";